import { cn } from "@/lib/utils";
import { SukhaCard } from "./SukhaCard";

export const SolidCard = ({
  children,
  className,
  sukhaCardClassName,
}: {
  children: React.ReactNode;
  className?: string;
  sukhaCardClassName?: string;
}) => {
  return (
    <div
      className={cn("flex justify-center p-4 w-full min-h-[600px]", className)}
    >
      <SukhaCard
        hover={false}
        className={cn(
          "justify-center bg-primary-800 backdrop-blur-sm border border-gray-400 w-full max-w-md",
          sukhaCardClassName
        )}
      >
        {children}
      </SukhaCard>
    </div>
  );
};
